import { Dropdown, Menu } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'
import config from '../Config'
import moment from 'moment'

const RolesTable = ({ data, onDelete, checkAccess }) => {
    return (
        <div className='table-responsive'>
            <table className='jean-table table'>
                <tbody>
                    {
                        data?.map((item, i) => {
                            return (
                                <>
                                    <tr key={item.id}>
                                        <td className='col-md-3'>
                                            <div className='therapist-info'>
                                                <p className='mb-1' style={{ fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#999' }}>Date</p>
                                                <p className='mb-0'>{moment(item.created_at).format("DD MMM, YYYY")}</p>
                                            </div>
                                        </td>

                                        <td>
                                            <div className='therapist-info'>
                                                <p className='mb-1' style={{ fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#999' }}>Role Name</p>
                                                <p className='mb-0'>{item.roleName}</p>
                                            </div>
                                        </td>

                                        <td className='col-md-3 pe-3'>
                                            <div className='d-flex justify-content-evenly'>
                                                {
                                                    checkAccess && checkAccess(7,3) &&
                                                    <Link className="dropdown-item px-2 text-center bg-green py-2  text-white rounded-4 me-3" to={`${config.appUrl}edit-role/${item.id}`}>
                                                        <i className="icon-pen mr-10 text-white"></i>
                                                        Edit
                                                    </Link>
                                                }
                                                {
                                                    checkAccess && checkAccess(7,4) &&
                                                    <button className="dropdown-item px-2 text-center bg-red py-2  text-white rounded-4" 
                                                    onClick={() => onDelete(item.id)} >
                                                        <i className="icon-trash2 mr-10 text-white"></i>
                                                        Delete
                                                    </button>
                                                }
                                            </div>
                                        </td>
                                    </tr>

                                </>
                            )
                        })
                    }

                    {
                        data?.length === 0 &&
                        <div className="alert alert-success ps-4">No Role Found !!</div>
                    }
                </tbody>
            </table>
        </div>
    )
}

export default RolesTable